import { MagicLinkAuthenticationErrorTypes } from "@meterup/proto/esm/portal";

// @ts-expect-error
export const MagicLinkErrorTypes: { [key in MagicLinkAuthenticationErrorTypes]: number } =
  Object.keys(MagicLinkAuthenticationErrorTypes).reduce(
    (memo, k, i) => ({ ...memo, [k as keyof typeof MagicLinkAuthenticationErrorTypes]: i }),
    {},
  );
